<template>
    <div>
        <div class="multi-select-box" @click="handleMultiSelectBoxClick">
            <span class="multi-select-placeholder" v-if="!selectedNames.length">{{ placeholder }}</span>
            <span class="multi-select-value" v-else>{{ displayValue }}</span>
        </div>
        <cube-popup v-model="showPopup" position="bottom">
            <div class="popup-content">
                <div class="popup-actions">
                    <button class="popup-btn cancel" @click="showPopup = false">取消</button>
                    <button class="popup-btn" @click="confirm">确定</button>
                </div>
                <div class="popup-title">{{ title }}</div>
                <div class="cube-checkbox-container">
                <cube-scroll 
					class="popup-options-scroll"
                    direction="vertical"
                    ref="customScroll">
                    <cube-checkbox-group v-model="localStringValue">
                        <cube-checkbox v-for="item in options" :key="item.value" :label="String(item.value)">
                            {{item.text }}
                        </cube-checkbox>
                    </cube-checkbox-group>
                 </cube-scroll>
                </div>
            </div>
        </cube-popup>
    </div>
</template>

<script>
export default {
    name: 'CubeMultiSelect',
    props: {
        value: {
            type: Array,
            default: () => []
        },
        options: {
            type: Array,
            default: () => []
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        title: {
            type: String,
            default: '请选择'
        }
    },
    data() {
        return {
            showPopup: false,
            localValue: [...this.value], // 原始类型数组
            localStringValue: [...this.value].map(v => String(v)), // 字符串数组用于checkbox-group
            touchStartY: 0, // 添加触摸起始位置
            isScrolling: false // 添加滚动状态标识
        };
    },
    watch: {
        value(val) {
            this.localValue = [...val];
            this.localStringValue = [...val].map(v => String(v));
        },
        localStringValue(val) {
            // 反向同步：将字符串数组转为原始类型数组
            const mapOrigin = (strArr) => {
                return this.options
                    .filter(opt => strArr.includes(String(opt.value)))
                    .map(opt => opt.value);
            };
            this.localValue = mapOrigin(val);
        }
    },
    computed: {
        selectedNames() {
            return this.options
                .filter(opt => this.value.includes(opt.value))
                .map(opt => opt.text);
        },
        // 根据需求添加显示值计算属性
        displayValue() {
            if (this.selectedNames.length === 1) {
                return this.selectedNames[0];
            } else if (this.selectedNames.length > 1) {
                return `${this.selectedNames[0]}[多选]`;
            }
            return '';
        }
    },
    methods: {
        handleMultiSelectBoxClick() {
            this.showPopup = true;
            this.$nextTick(() => {
                this.$refs.customScroll && this.$refs.customScroll.refresh();
            });
        },
        confirm() {
            console.log(this.localValue)
            this.$emit('input', this.localValue);
            this.$emit('change', this.localValue);
            this.showPopup = false;
        },
        // 添加触摸事件处理函数
        handleTouchStart(e) {
            this.touchStartY = e.touches[0].clientY;
            this.isScrolling = false;
        },
        handleTouchMove(e) {
            const container = e.currentTarget;
            const deltaY = e.touches[0].clientY - this.touchStartY;
            const scrollTop = container.scrollTop;
            const scrollHeight = container.scrollHeight;
            const clientHeight = container.clientHeight;

            // 判断是否在容器边界滚动
            if ((scrollTop === 0 && deltaY > 0) ||
                (scrollTop + clientHeight >= scrollHeight && deltaY < 0)) {
                e.preventDefault();
                return;
            }

            this.isScrolling = true;
            // 阻止默认行为以防止页面滚动
            if (this.isScrolling) {
                e.stopPropagation();
            }
        },
        handleTouchEnd() {
            this.isScrolling = false;
        }
    }
};
</script>

<style scoped>
.multi-select-box {
    width: 100%;
    height: 30px;
    color: #d9e3fd;
    border-radius: 5px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    cursor: pointer;
    border: 1px solid #67696f;
    font-size: 15px;
    box-sizing: border-box;
    transition: box-shadow 0.2s;
}

.multi-select-box:active,
.multi-select-box:focus,
.multi-select-box:hover {
    box-shadow: 0 0 0 2px #28faff33;
}

.multi-select-placeholder {
    color: #96abe4;
    font-size: 15px;
}

.multi-select-value {
    color: #00a0de;
    font-size: 15px;
    word-break: break-all;
}

.cube-popup {
    z-index: 9999;
}

.popup-content {
    background: #fff;
    padding: 20px 16px 12px 16px;
    min-height: 220px;
    max-height: 320px;
    height: 320px;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
    touch-action: pan-y;
    /* 添加以下属性以增强滚动性能 */
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);
}

.popup-title {
    color: #232b4a;
    font-size: 16px;
    margin-bottom: 12px;
    text-align: center;
}

.popup-actions {
    position: relative;
    height: 0;
}

.popup-btn {
    position: absolute;
    top: -12px;
    min-width: 56px;
    height: 32px;
    border: none;
    border-radius: 16px;
    color: #00a0de;
    font-size: 15px;
    padding: 0 14px;
    z-index: 2;
    background: #ffffff;
}

.popup-btn.cancel {
    left: 0;
    background: #ffffff;
    color: #999;
}

.popup-btn:not(.cancel) {
    right: 0;
}

.cube-checkbox-group {
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.cube-checkbox-container {
    height: calc(100% - 30px);
}

.cube-checkbox {
    position: relative;
    text-align: left;
    color: #666;
    width: 180px;
    padding-left: 45px;
}

/* 使用深度选择器来确保样式能够穿透到cube-ui组件内部 */
/* 特别针对i标签的样式 */
.cube-checkbox_checked ::v-deep .cube-checkbox-ui i {
    color: #00a0de !important;
}

.popup-options-scroll{
	height: 100%;
}
</style>
